import { Link } from 'react-router-dom';
import { latestUpdates } from '@/mocks/comics';

export default function LatestUpdateSection() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
              最新更新
            </h2>
            <p className="text-foreground-500 text-sm">追更连载，精彩不停</p>
          </div>
          <Link
            to="/category?filter=latest"
            className="hidden sm:inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
          >
            查看更多
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6" data-product-shop>
          {latestUpdates.map((comic) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="group flex gap-4 p-4 rounded-xl bg-background-50 border border-background-200 hover:border-primary-300 transition-all duration-200 hover:-translate-y-0.5"
            >
              {/* Cover */}
              <div className="flex-shrink-0 w-20 md:w-24 aspect-[3/4] rounded-lg overflow-hidden">
                <img
                  src={comic.coverImage}
                  alt={comic.title}
                  title={`${comic.title} - 奇妙漫画最新更新`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
              </div>

              {/* Info */}
              <div className="flex-1 min-w-0 flex flex-col justify-between">
                <div>
                  <h3 className="font-heading font-semibold text-foreground-900 text-sm line-clamp-2 mb-1">
                    {comic.title}
                  </h3>
                  <p className="text-xs text-foreground-400 line-clamp-1">{comic.author}</p>
                </div>
                <div className="space-y-1.5">
                  <div className="flex items-center gap-1 text-xs">
                    <span className="flex items-center gap-1 text-amber-500">
                      <i className="ri-star-fill text-[10px]"></i>
                      {comic.rating}
                    </span>
                    <span className="text-foreground-300">|</span>
                    <span className="text-foreground-400">{comic.chapters.length}话</span>
                  </div>
                  <div className="flex items-center gap-1 text-xs text-accent-600">
                    <i className="ri-time-line text-[10px]"></i>
                    <span>更新至 {comic.chapters[comic.chapters.length - 1]?.title}</span>
                  </div>
                  <div className="flex flex-wrap gap-1">
                    {comic.tags.slice(0, 2).map((tag) => (
                      <span key={tag} className="text-[10px] px-1.5 py-0.5 rounded-md bg-secondary-100 text-secondary-700">
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-8 sm:hidden">
          <Link
            to="/category?filter=latest"
            className="inline-flex items-center gap-2 text-sm font-medium text-primary-600"
          >
            查看更多
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}